import api from "./api";

export const contactsService = {
  getAll: async (
    page = 1,
    limit = 10,
    search = "",
    sortBy = "createdAt",
    sortOrder = "desc",
  ) => {
    const response = await api.get("/api/admin/contacts", {
      params: { page, limit, search, sortBy, sortOrder },
    });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/api/admin/contacts/${id}`);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/api/admin/contacts/${id}`);
    return response.data;
  },
};
